import isEqual from "lodash/isEqual";
import type { FunctionComponent } from "react";
import { useMemo, useRef, useState } from "react";

import { useSearchContext } from "~/components/search/contexts";
import type { ArticlesSearchOrderByInput } from "~/queries/__generated__/searchArticleResultPaginationQuery.graphql";

import { DefaultSortingOption, SortingOptions } from "./const";
import {
  SortingDisplay,
  SortingDisplayContainer,
  StyledArrowIcon,
  StyledMenu,
  StyledMenuItem,
} from "./styles";

type Props = {
  className?: string;
};

export const SearchResultListSortingMenu: FunctionComponent<Props> = ({ className }) => {
  const { orderBy, setOrderBy } = useSearchContext();
  const anchorElement = useRef<HTMLSpanElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenMenu = () => {
    setIsOpen(true);
  };

  const handleCloseMenu = (selectedOrderBy?: ArticlesSearchOrderByInput) => {
    setIsOpen(false);
    selectedOrderBy &&
      setOrderBy?.({
        ...selectedOrderBy,
      });
  };

  const selectedSortingOption = orderBy ?? DefaultSortingOption.value;
  const selectedSortingText = useMemo(
    () => SortingOptions.find(option => isEqual(selectedSortingOption, option.value))?.text,
    [selectedSortingOption],
  );
  return (
    <>
      <SortingDisplayContainer className={className}>
        <SortingDisplay
          aria-expanded={isOpen ? "true" : undefined}
          aria-haspopup="true"
          ref={anchorElement}
          onClick={handleOpenMenu}
        >
          {selectedSortingText}
          <StyledArrowIcon $isExpand={isOpen} />
        </SortingDisplay>
      </SortingDisplayContainer>
      {/* TODO: without toggle the menu will be reopened when the component is remounted */}
      {isOpen && (
        <StyledMenu
          anchorEl={anchorElement.current}
          anchorOrigin={{
            horizontal: "left",
            vertical: "top",
          }}
          open={isOpen}
          transformOrigin={{
            horizontal: "left",
            vertical: "top",
          }}
          onClose={() => handleCloseMenu()}
        >
          {SortingOptions.map((option, index) => (
            <StyledMenuItem
              $isSelected={isEqual(selectedSortingOption, option.value)}
              key={index}
              onClick={() => {
                handleCloseMenu(option.value);
              }}
            >
              {option.text}
            </StyledMenuItem>
          ))}
        </StyledMenu>
      )}
    </>
  );
};

SearchResultListSortingMenu.displayName = "SearchResultListSortingMenu";
